import type { FC } from 'react';

import { useInsertApproval } from '@/hooks/mutations/approval';

import ApprovalForm from '../forms/ApprovalForm';
import type { ApprovalFormValues } from '../forms/approvalFormSchema';

type Props = {
  parentId?: string;
  onDismiss?: () => void;
  onDelete?: () => Promise<void>;
  readOnly?: boolean;
};

const CreateModal: FC<Props> = ({
  onDismiss,
  parentId,
  onDelete,
  readOnly,
}) => {
  const { insertApproval } = useInsertApproval();

  const onSave = async (data: ApprovalFormValues) => {
    await insertApproval({
      Workflow: data.Workflow,
      ParentId: data.ParentId,
      InFlightEditRule: data.InFlightEditRule,
      levels: {
        data: data.levels.map((level, i) => ({
          Description: 'Approval Level',
          SequenceOrder: i,
          ApprovalRuleType: level.ApprovalRuleType,
          approvers: {
            data: level.approvers.map((approver) => ({
              UserId: approver.UserId,
              OwnerApprover: approver.OwnerApprover,
              UserGroupId: approver.UserGroupId,
            })),
          },
        })),
      },
    });
  };

  return (
    <ApprovalForm
      parentId={parentId}
      onSave={onSave}
      onDismiss={onDismiss}
      onDelete={onDelete}
      readOnly={readOnly}
    />
  );
};

export default CreateModal;
